export const windowsData = {
  ps5: [
    {
      label: "Spring Boot",
      parameters: [
        "$backendPath",
        "$backendPort",
        "$javaPath",
        "$springProfile",
        "$gitBranch",
      ],
      usage: ".\\BootStartMyDev.ps1",
      result: "The backend server will be started in a new PowerShell window.",
      code: "Boot",
      fileName: "BootStartMyDev.ps1",
      powershellVersion: "5",
    },
    {
      label: "Flask",
      parameters: ["$backendPath", "$backendPort", "$pythonPath", "$gitBranch"],
      usage: ".\\BootStartMyDev.ps1",
      result: "The backend server will be started in a new PowerShell window.",
      code: "Flask",
      fileName: "FlaskStartMyDev.ps1",
      powershellVersion: "5",
    },
    {
      label: "React",
      parameters: ["$frontendPath", "$frontendPort", "$gitBranch"],
      usage: ".\\ReactStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "React",
      fileName: "ReactStartMyDev.ps1",
      powershellVersion: "5",
    },
    {
      label: "Angular",
      parameters: ["$frontendPath", "$frontendPort", "$gitBranch"],
      usage: ".\\NgStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "Ng",
      fileName: "NgStartMyDev.ps1",
      powershellVersion: "5",
    },
    {
      label: "React + Spring Boot",
      parameters: [
        "$frontendPath",
        "$frontendPort",
        "$backendPath",
        "$backendPort",
        "$javaPath",
        "$springProfile",
        "$gitBranch",
      ],
      usage: ".\\ReactBootStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "ReactBoot",
      fileName: "ReactBootStartMyDev.ps1",
      powershellVersion: "5",
    },
    {
      label: "Angular + Spring Boot",
      parameters: [
        "$frontendPath",
        "$frontendPort",
        "$backendPath",
        "$backendPort",
        "$javaPath",
        "$springProfile",
        "$gitBranch",
      ],
      usage: ".\\NgBootStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "NgBoot",
      fileName: "NgBootStartMyDev.ps1",
      powershellVersion: "5",
    },
  ],
  ps7: [
    {
      label: "Spring Boot",
      path: "boot-start-my-dev",
      parameters: [
        "$backendPath",
        "$backendPort",
        "$javaPath",
        "$springProfile",
        "$gitBranch",
      ],
      usage: ".\\BootStartMyDev.ps1",
      result: "The backend server will be started in a new PowerShell window.",
      code: "Spring Boot",
      fileName: "BootStartMyDev.ps1",
      powershellVersion: "7",
    },
    {
      label: "Flask",
      parameters: ["$backendPath", "$backendPort", "$pythonPath", "$gitBranch"],
      usage: ".\\BootStartMyDev.ps1",
      result: "The backend server will be started in a new PowerShell window.",
      code: "Flask",
      fileName: "FlaskStartMyDev.ps1",
      powershellVersion: "7",
    },
    {
      label: "React",
      parameters: ["$frontendPath", "$frontendPort", "$gitBranch"],
      usage: ".\\ReactStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "React",
      fileName: "ReactStartMyDev.ps1",
      powershellVersion: "7",
    },
    {
      label: "Angular",
      parameters: ["$frontendPath", "$frontendPort", "$gitBranch"],
      usage: ".\\NgStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "Ng",
      fileName: "NgStartMyDev.ps1",
      powershellVersion: "7",
    },
    {
      label: "React + Spring Boot",
      parameters: [
        "$frontendPath",
        "$frontendPort",
        "$backendPath",
        "$backendPort",
        "$javaPath",
        "$springProfile",
        "$gitBranch",
      ],
      usage: ".\\ReactBootStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "ReactBoot",
      fileName: "ReactBootStartMyDev.ps1",
      powershellVersion: "7",
    },
    {
      label: "Angular + Spring Boot",
      parameters: [
        "$frontendPath",
        "$frontendPort",
        "$backendPath",
        "$backendPort",
        "$javaPath",
        "$springProfile",
        "$gitBranch",
      ],
      usage: ".\\NgBootStartMyDev.ps1",
      result: "The frontend server will be started in a new PowerShell window.",
      code: "NgBoot",
      fileName: "NgBootStartMyDev.ps1",
      powershellVersion: "7",
    },
  ],
  linux: [
    {
      label: "SpringBoot",
      parameters: [
        "backendPath",
        "backendPort",
        "javaPath",
        "springProfile",
        "gitBranch",
      ],
      usage: "./BootStartMyDev.sh",
      result: "The backend server will be started in a new terminal window.",
      code: "Boot",
      fileName: "BootStartMyDev.sh",
    },
    {
      label: "Flask",
      parameters: ["backendPath", "backendPort", "pythonPath", "gitBranch"],
      usage: "./FlaskStartMyDev.sh",
      result: "The backend server will be started in a new terminal window.",
      code: "Flask",
      fileName: "FlaskStartMyDev.sh",
    },
    {
      label: "React",
      parameters: ["frontendPath", "frontendPort", "gitBranch"],
      usage: "./ReactStartMyDev.sh",
      result: "The frontend server will be started in a new terminal window.",
      code: "React",
      fileName: "ReactStartMyDev.sh",
    },
    {
      label: "Angular",
      parameters: ["frontendPath", "frontendPort", "gitBranch"],
      usage: "./NgStartMyDev.sh",
      result: "The frontend server will be started in a new terminal window.",
      code: "Ng",
      fileName: "NgStartMyDev.sh",
    },
    {
      label: "React + Spring Boot",
      parameters: [
        "frontendPath",
        "frontendPort",
        "backendPath",
        "backendPort",
        "javaPath",
        "springProfile",
        "gitBranch",
      ],
      usage: "./ReactBootStartMyDev.sh",
      result: "The frontend and backend servers will be started in new terminal windows.",
      code: "ReactBoot",
      fileName: "ReactBootStartMyDev.sh",
    },
    {
      label: "Angular + Spring Boot",
      parameters: [
        "frontendPath",
        "frontendPort",
        "backendPath",
        "backendPort",
        "javaPath",
        "springProfile",
        "gitBranch",
      ],
      usage: "./NgBootStartMyDev.sh",
      result: "The frontend and backend servers will be started in new terminal windows.",
      code: "NgBoot",
      fileName: "NgBootStartMyDev.sh",
    },
  ],
};
